import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedComponentsModule } from '../../shared/shared-components.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { SearchformComponent } from './components/search-form/search-form.component';
import { TabNavigationComponent } from './components/tab-navigation/tab-navigation.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { BrowseFormComponent } from './components/browse-form/browse-form.component';
import { MainComponent } from './main.component';
import { FindPCPComponent } from './components/findpcp/findpcp.component';
import { EmployergroupComponent } from './components/employergroup/employergroup.component';
import { HcbsImageComponent } from './components/hcbs-image/hcbs-image.component';
import { SearchNetworkLabelComponent } from './components/browse-form/search-network-label/search-network-label.component';

import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaFormsModule } from 'ng-recaptcha';
import { environment } from '@env/environment';
import { MedicationSearchformComponent } from './components/medication-search-form/medication-search-form.component';
import { LocationSearchComponent } from './components/location-search/location-search.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedComponentsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        MatFormFieldModule, MatInputModule, MatSelectModule, MatAutocompleteModule, MatIconModule
    ],
    declarations: [
        MainComponent,
        SearchformComponent,
        TabNavigationComponent,
        LoginFormComponent,
        BrowseFormComponent,
        FindPCPComponent,
        EmployergroupComponent,
        HcbsImageComponent,
        SearchNetworkLabelComponent,
        MedicationSearchformComponent,
        LocationSearchComponent
    ],
    exports: [
        MainComponent,
        SearchformComponent,
        TabNavigationComponent,
        LoginFormComponent,
        BrowseFormComponent,
        FindPCPComponent,
        EmployergroupComponent,
        HcbsImageComponent,
        SearchNetworkLabelComponent,
        MedicationSearchformComponent,
        LocationSearchComponent
    ],
    providers: [{
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.captchaKey,
            } as RecaptchaSettings,
        }]
})
export class MainModule { }
